import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { HelpIcon } from 'react-magma-icons';

import HELP_LINKS_LIST from './helpLinksList';


const HeaderBaseButtonsComponent = ({ location }) => (
  <div className="header-main__buttons">
    <a href={HELP_LINKS_LIST[location.pathname]} target="_blank" rel="noreferrer noopener" className="header-main__button main-button ml-20">
      <div className="mr-5 inline-block">
        <HelpIcon size="18" aria-hidden="true" />
      </div>
      Help
    </a>
  </div>
);


HeaderBaseButtonsComponent.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(HeaderBaseButtonsComponent);
